import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '../Services/error-handler.service';
import { Router } from '@angular/router';
import { AuthTokenService } from '../Services/auth-token.service';
import { AccessDecision } from '../../../Enums/access-decision.enum';

function isConsentRequiredRejection(error: HttpErrorResponse): boolean {
  return (
    error.status === 403 &&
    (error.error as { access_decision?: string } | null)?.access_decision ===
      AccessDecision.CONSENT_REQUIRED
  );
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const authTokenService = inject(AuthTokenService);
  const router = inject(Router);

  const skipError = req.headers.get('skip-error') === 'true';

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          authTokenService.setReturnUrl(router.url);
        }
        if (isConsentRequiredRejection(error)) {
          return throwError(() => error);
        }
        if (!skipError || error.status === 401) {
          errorHandler.handleError(error);
        }
      }
      return throwError(() => error);
    })
  );
};
